import { render, staticRenderFns } from "./CapitalReceiptDetail.vue?vue&type=template&id=12170b6f&scoped=true&"
import script from "./CapitalReceiptDetail.vue?vue&type=script&lang=ts&"
export * from "./CapitalReceiptDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalReceiptDetail.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./CapitalReceiptDetail.vue?vue&type=style&index=1&id=12170b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12170b6f",
  null
  
)

export default component.exports